import React from 'react';

import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import validator from 'validator';
import InfoTooltipComponent from '../../commons/infoTooltip/infoTooltipComponent';
import { useTranslation } from 'react-i18next';
import '../../assets/validatedCheckbox.css';
import './memberUpdateView.css';

const MemberUpdateView = ({
    firstName,
    lastName,
    utuAccount,
    email,
    homeTown,
    tyyMember,
    submitMainForm,
    handleInputChange,
    success,
    message,
    matchPassword,
    handlePasswordReset,
}) => {
    const { t } = useTranslation();

    return (
        <div className="container">
            <ValidationForm onSubmit={submitMainForm}>
                <Form.Group>
                    <Form.Label>{t('memberUpdate.firstName')}</Form.Label>
                    <TextInput
                        name="firstName"
                        id="firstName"
                        defaultValue={firstName}
                        errorMessage={{
                            required: t('memberUpdate.firstNameRequired'),
                            pattern: t('memberUpdate.firstNameInvalid'),
                        }}
                        required
                        pattern="[a-zA-Z\u00c0-\u017e- ]{2,40}$"
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>{t('memberUpdate.lastName')}</Form.Label>
                    <TextInput
                        name="lastName"
                        id="lastName"
                        defaultValue={lastName}
                        errorMessage={{
                            required: t('memberUpdate.lastNameRequired'),
                            pattern: t('memberUpdate.lastNameInvalid'),
                        }}
                        required
                        pattern="[a-zA-Z\u00c0-\u017e- ]{2,25}$"
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>{t('memberUpdate.utuAccountLabel')}</Form.Label>
                    <TextInput
                        name="utuAccount"
                        id="utuAccount"
                        defaultValue={utuAccount}
                        errorMessage={{
                            required: t('memberUpdate.utuAccountRequired'),
                            pattern: t('memberUpdate.utuAccountInvalid'),
                        }}
                        pattern="[a-öA-Ö.]{2,30}$"
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>{t('memberUpdate.email')}</Form.Label>
                    <TextInput
                        name="email"
                        defaultValue={email}
                        id="email"
                        errorMessage={{
                            required: t('memberUpdate.emailRequired'),
                            validator: t('memberUpdate.emailInvalid'),
                        }}
                        validator={validator.isEmail}
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>{t('memberUpdate.homeTown')}</Form.Label>
                    <TextInput
                        name="homeTown"
                        id="homeTown"
                        defaultValue={homeTown}
                        errorMessage={{
                            required: t('memberUpdate.homeTownRequired'),
                            pattern: t('memberUpdate.homeTownInvalid'),
                        }}
                        required
                        pattern="[a-zA-Z\u00c0-\u017e- ]{2,25}$"
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Check
                        type="checkbox"
                        checked={tyyMember}
                        onChange={handleInputChange}
                        name="tyyMember"
                        label={
                            <>
                                {t('memberUpdate.tyyMember')}{' '}
                                <InfoTooltipComponent
                                    text={t('common.tyyMemberInfo')}
                                />
                            </>
                        }
                    />
                </Form.Group>
                <hr />
                {message && !success ? (
                    <Alert variant={!success ? 'danger' : 'success'}>
                        {t(message.key, message.params)}
                    </Alert>
                ) : null}
                <div className="buttons-row">
                    <Link className="btn btn-secondary secondary" to="/member">
                        {t('common.back')}
                    </Link>
                    <div className="tight-row">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => handlePasswordReset()}
                        >
                            {t('memberUpdate.passwordReset')}
                        </button>
                        <button className="btn btn-success">
                            {t('memberUpdate.update')}
                        </button>
                    </div>
                </div>
            </ValidationForm>
        </div>
    );
};

export default MemberUpdateView;
